import { JetView } from "webix-jet";
import Toolbar from "./toolbar";

import { createState } from "jet-restate";

export default class RolesView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		this.Compact = this.getParam("compact", true);
		this.setParam(
			"state",
			createState({ mode: "grid", name: _("Roles"), search: "" })
		);

		return {
			margin: 10,
			padding: 10,
			css: "webix_um_tableview",
			cols: [
				{
					localId: "list",
					rows: [
						Toolbar,
						{
							$subview: true,
							name: "center",
						},
					],
				},
				{ $subview: "_hidden", name: "default" },
			],
		};
	}

	init() {
		this.on(this.getParam("state").$changes, "mode", v => {
			this.show("roles." + v, { target: "center" });
			if (v === "matrix") {
				this.setParam("id", null);
				this.show("./_hidden");
			}
		});

		this.on(this.app, "roles.back:click", () => this.HideEditor());
	}

	ShowDetails(id) {
		const now = this.getParam("id");
		const next = id.toString();

		if (this.getParam("compact", true) || !now) {
			this.app.callEvent("details:item-click", ["roles", next]);
		} else if (now !== next) {
			this.setParam("id", next, true);
		}
	}

	ToggleVisible(mode) {
		if (mode) {
			this.show("_hidden", { target: "default" });
			this.show("roles.matrix", { target: "center" });
			this.$$("toolbar").showBatch("matrix");
		} else {
			this.show("roles.grid", { target: "center" });
			this.$$("toolbar").showBatch("default");
		}
	}
}
